import React from 'react';
import { P, TextLink } from '@ovotech/nebula';
import { useDecision } from '@/src/utils/optimizely';
import { useContractsQuery } from '@/src/api/use-contracts-query';
import { Contract } from '@/src/api/contracts/types';
import { BETA_WEBSITE_BANNER } from '@/src/constants/feature-flags';
import { BETA_WEBSITE_URL } from '@/src/constants/endpoints';
import {
  getHasStartedSupply,
  getIsEligiblePaymentMethod,
} from '@/src/utils/newWebEligibility/newWebEligibility';
import styles from './BetaWebsiteBanner.module.css';

type Props = {
  accountId: string | null | undefined;
};

const isEligible = (contracts: Contract[]): boolean =>
  (getHasStartedSupply(contracts) ?? false) &&
  (getIsEligiblePaymentMethod(contracts) ?? false);

const BetaWebsiteBannerInner = () => {
  const [decision] = useDecision(BETA_WEBSITE_BANNER);

  if (!decision.enabled) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.inner}>
        <P>
          {"You're in an older version of the site. "}
          <TextLink href={BETA_WEBSITE_URL}>Switch over</TextLink>
          {' to beta to see new features and updates.'}
        </P>
      </div>
    </div>
  );
};

// Eligibility is decided in code; the Optimizely flag is just a global on/off
// switch for the banner. Gate on contracts loading and eligibility first so the
// flag decision (and its impression) only runs for eligible customers.
export const BetaWebsiteBanner = ({ accountId }: Props) => {
  const { data, isSuccess } = useContractsQuery(accountId);
  if (!isSuccess || !data) return null;
  if (!isEligible(data.data)) return null;
  return <BetaWebsiteBannerInner />;
};
